<template>
  <div>
    <tooltip label="Edit" type="default" placement="left">
      <a class="button button-table is-small" @click="edit()">
        <i class="fa fa-pencil"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Message from '../../utils/message'
  import Platform from './Platform'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      edit () {
        let propsData = {
          context: this,
          platform_id: this.data.id,
          title: 'Edit Platform - ' + this.data.name,
          callback: 'platformCallback',
          edit: true
        }
        Platform.openPlatform(propsData)
      },
      platformCallback (result) {
        let propsData = null
        if (result.ok) {
          propsData = {
            title: 'Success',
            message: result.message,
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          this.$parent.loadData()
        }
        Message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// PlatformTableButtons.vue?276d87fe